<template>
  <el-dialog
    class="modal-modify-takeawaySys"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
  >
    <div class="content">
      <el-form
        ref="modify"
        :rules="rules"
        v-loading="isLoading"
        label-position="right"
        :model="formData"
        class="platform-modify__form"
      >
        <el-form-item label="目录名称:" prop="cataogName1">
          <el-input v-model="formData.cataogName1" placeholder="必填" style="width: 440px;"></el-input>
          <span class="input-tips">*支持16个中文字符或32个英文字符, 并只包含.。，,()（）【】[]、\_-— 以上字符</span>
        </el-form-item>

        <el-form-item label="目录类型:" prop="cataogType">
          <el-select v-model="formData.cataogType" style="width: 200px;" :disabled="formType === 'edit'">
            <el-option
              v-for="item in formData.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <span class="input-tips">*必填</span>
        </el-form-item>

        <el-form-item label="目录属性:" prop="catalogProperties" v-if="formData.cataogType === '1'">
          <el-select v-model="formData.catalogProperties" style="width: 200px;" @change="changeType" multiple >
            <el-option label="对外标准" :value="2"></el-option>
            <el-option label="对内文档" :value="1"></el-option>
          </el-select>
          <span class="input-tips">*必填</span>
        </el-form-item>

        <el-form-item label="上级目录:" prop="parentId">
          <el-select v-model="formData.parentId" filterable style="width: 200px;">
            <el-option :value="0" label="无"></el-option>
            <el-option
              style="width: 220px;"
              v-for="item in formData.syses"
              :key="item.cid"
              :label="item.cataogName"
              :value="item.cid"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="序号:" prop="cataogSort">
          <el-input v-model="formData.cataogSort" placeholder="必填" style="width: 200px;"></el-input>
          <span class="input-tips">*数字越小越靠前</span>
        </el-form-item>

        <el-form-item label="是否在开放平台显示:" prop="showInMarket">
          <cd-switch
            class="switch__btn"
            v-model="formData.showInMarket"
            :true-value="1"
            :false-value="0"
          >
            <span slot="open">显示</span>
            <span slot="close">隐藏</span>
          </cd-switch>
        </el-form-item>

        <el-form-item label="页面内容:" prop="cataogContent">
          <!-- 创建文本编辑器 -->
          <div id="main">
            <mavon-editor v-model="formData.cataogContent" ref="md" @imgAdd="$imgAdd"/>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="save__btn" @click="$_submit">确认</el-button>
      <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";
import OSS from "ali-oss";
import Axios from "axios";
export default {
  name: "modal-modify",
  props: {
    title: { type: String, default: "" },
    formType: { type: String, default: "add" },
    modalData: { type: Object, default: {} }
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      datalist: [],

      formData: {
        syses: [],
        cataogName1: "",
        cataogName: "",
        cataogType: "",
        cid: "",
        parentId: 0,
        parentName: "",
        catalogLevel: 0,
        cataogSort: "",
        cataogContent: "",
        showInMarket: 1,
        catalogProperties: [2],
        options: [
          {
            value: "1",
            label: "接口目录"
          },
          {
            value: "2",
            label: "公告说明目录"
          },
          {
            value: "3",
            label: "接口指引目录"
          }
        ]
      },
      modal: {
        show: false,
        title: "",
        template: "",
        data: {}
      },
      rules: {
       cataogName1: [
          { required: true, message: "请输入目录名称", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (typeof value !== "undefined" && value !== "") {
                if (Utils.getStrLength(value) > 32) {
                  callback(new Error(`16个中文字符或32个英文字符`));
                  return false;
                } else if (
                  value.match(
                    /^[\u0391-\uFFE5A-Za-z0-9.。，,()（）【】\[\]、\\_\-—]+$/
                  ) == null
                ) {
                  callback(
                    new Error("只包含 .。，,()（）【】[]、\\_-— 以上字符")
                  );
                  return false;
                }
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        // cataogType: [
        //   { required: true, message: "请选择目录类型", trigger: "blur" }
        // ],
        parentId: [{ required: true, message: "请选择目录", trigger: "blur" },],
        cataogSort: [
          { required: true, message: "请输入目录排序", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== "" && value.length > 6) {
                callback(new Error("不能超过六位数字！"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              const age = /^[0-9]*$/;
              if (!age.test(value)) {
                callback(new Error("只能输入为数字"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {
    'formData.cataogType'(val) {
      if (val !== 0){
        this.formData.syses = this.datalist.filter(ele=>ele.cataogType==val).concat([]);
      }
    },
    "formData.parentId"(val) {
      if (val !== "") {
        this.datalist.find(ele => {
          if (ele.cid == val) {
            this.formData.cataogName = ele.cataogName;
            this.formData.parentId = ele.cid;
          }
        });
      }
    }
  },
  methods: {
    //md图片处理
    // 绑定@imgAdd event
    async $imgAdd(pos, $file){
        // 第一步.将图片上传到服务器.
       const filename = $file.name;
       let fileType = filename.replace(/([^\.]+\.)+(\S+)/g, "$2");
       const account = await this.$service.url("getUploadAccount");

      if (account.status !== 1) {
        $MessageBox.alert({ content: "获取配置失败" });
        return false;
      }
      let {
        region,
        accessKeyId,
        accessKeySecret,
        bucket,
        path,
        tmpPath
      } = account.data;

      this.client = new OSS({
        region,
        accessKeyId,
        accessKeySecret,
        bucket
      });

      // 上传阿里
      const filePath = `/${path}/${tmpPath}/paas/${Utils.createKey()}-${Utils.createKey()}-${Utils.createKey()}.${fileType}`;

      try {
        let result = await this.client.multipartUpload(filePath, $file);
        if (result.res.status === 200) {
          let url = result.res.requestUrls[0];
          if (typeof innerRegion !== "undefined" && innerRegion !== "") {
            url = url.replace(region, innerRegion);
          }
           this.$refs.md.$img2Url(pos, url.substring(
            0,
            url.lastIndexOf("?uploadId") === -1
              ? url.length
              : url.lastIndexOf("?uploadId")
          ));
          
        }
      } catch (e) {
        if (e.name !== "cancel" && status !== 0) {
          $MessageBox.alert({ content: "上传失败" });
        }
      }
    },
    filterParent(catalogPropArr, props){
      let temp = []
      for(const item of props){
        catalogPropArr.includes(item) ? temp.push(item) : ''
      }
      return temp.length && temp.length === props.length
    },
    changeType(val) {
      const cataogType = this.formData.cataogType;
      this.formData.syses = this.datalist.filter(ele=>ele.cataogType == cataogType && this.filterParent(ele.catalogProperties, val)).concat([]);
      //重置已选上级目录
      this.formData.parentId = 0,
      this.formData.parentName = ""
    },
    $_submit() {
      if (this.formData.cataogType === "") {
        $MessageBox.alert({ content: "请选择目录类型" });
        return false;
      }
      this.$refs["modify"].validate(valid => {
        if (valid) {
          const self = this;
          let action = "addCatalog";
          let {
            cataogSort,
            cataogType,
            parentName,
            parentId,
            cataogName,
            cataogName1,
            cataogContent,
            showInMarket,
            catalogLevel,
            catalogProperties
          } = this.formData;
          let postData = {
            cataogSort,
            cataogType,
            parentName,
            parentId,
            cataogName:cataogName1,
            cataogContent,
            showInMarket,
            catalogLevel
          };
          if (cataogType === "1") {
            Object.assign(postData, {
              catalogProperties
            })
          }
          if (self.formType === "edit") {
            action = "editCatalog";
            Object.assign(postData, { cid: this.formData.cid });
          }
          
          self.isLoading = true;
          self.$service.post(action, postData).then(result => {
            self.isLoading = false;
            if (result.$.checkResult(result, true)) {
              $MessageBox.alert({
                content: result.msg,
                onOk() {
                  self.visible = false;
                  self.$emit("callback");
                }
              });
            }
          });
        }
      });
    },

    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
 async created() {
      // 获取上级目录
    await this.$service
      .post("getAllCatalog", {
        pageNow: 1,
        pageSize: 9999
      })
      .then(result => {
        if (result.$.checkResult(result, true)) {
          this.datalist = result.data.map(item => {
            item.catalogProperties = item.catalogProperties || []
            return item
          });
        }
      });
    if (this.formType === "edit") {
      let {
        cid,
        cataogSort,
        cataogType,
        parentName,
        parentId,
        cataogName,
        cataogContent,
        showInMarket,
        cataogName1,
        catalogLevel,
        catalogProperties
      } = this.modalData;
      this.formData.cid = cid;
      this.formData.cataogSort = cataogSort;
      this.formData.cataogType = cataogType + "";
      this.formData.parentName = parentName;
      this.formData.parentId = parentId;
      this.formData.cataogName1 = cataogName+"";
      this.formData.cataogContent = cataogContent;
      this.formData.catalogLevel = catalogLevel;
      this.formData.showInMarket = showInMarket==undefined ? 1 : showInMarket;
      this.formData.catalogProperties = catalogProperties;
    }
  },
 mounted() {
    this.visible = true;
 }
};
</script>

<style lang="scss" scoped>
.select-btn__span {
  display: inline-block;
  border-radius: 3px;
  background-color: #1895dd;
  min-width: 65px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  white-space: nowrap;
  cursor: pointer;
  color: #fff;
}
.modal-modify-takeawaySys {
  padding-left: 24px;
}
.content {
  padding: 20px 30px;
  height: 100%;
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
    font-weight: 700;
  }
}
.select__btn {
  margin-left: 8px;
  vertical-align: top;
}
.type__chk {
  margin: {
    top: 5px;
    right: 64px;
  }
}
.input-tips {
  margin-left: 10px;
}
</style>





